import { Drawer, Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const CourseFilterStyle = withTheme(styled(Box)`
  .MuiList-root {
    padding-top: 0;
  }
  .submit-line-separator {
    border-width: 0;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.12);
    border-top-width: thin;
  }
  .MuiDivider-root.submit-line-separator {
    margin-bottom: 0;
  }
  .title {
    font-weight: bold;
  }
  .title > span {
    font-weight: bold;
  }
  .reset-filter-button {
    height: 47px;
    color: ${(props: any) => props.theme.palette.primary.main};
  }
`);

export const CourseFilterDrawerStyle = withTheme(styled(Drawer)`
  .MuiDrawer-paper {
    width: 390px;
    background-color: transparent;
    box-shadow: none;
    flex-direction: row;
    padding-bottom: 72px;
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .MuiDrawer-paper {
      width: 328px;
    }
  }
  .MuiList-root {
    overflow: hidden;
  }
  .filter-container {
    width: 320px;
    border-radius: 0px;
    overflow: hidden;
    background-color: white;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .filter-container {
      width: 258px;
    }
  }
  .filter-header {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    margin: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .filter-categoryId {
    border: unset;
  }
  .filter-content {
    overflow-y: auto;
  }
  .filter-list-container {
    overflow-y: auto;
    position: relative;
  }
  .close-button-container {
    height: 100%;
    width: 70px;
  }
  .close-button {
    height: 50px;
    width: 50px;
    top: 16px;
    left: 10px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    &:hover {
      background-color: white;
    }
  }

  .submit-button-container {
    position: fixed;
    bottom: 0px;
    right: 0;
    width: 320px;
    background: white;
    ${(props: any) => props.theme.breakpoints.down('sm')} {
      width: 258px;
    }
  }
`);
